module.exports = __webpack_public_path__ + "img/Iconly-Light-Outline-Send.860fa72d.svg";